// extracted by mini-css-extract-plugin
export default {"tabContent":"N25WbwyYdS"};